module.exports = __webpack_public_path__ + "img/mysc@2x.f17a4775.png";